module.exports = __webpack_public_path__ + "img/benjamin_biolay.7d01c48c.jpg";